
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import AddSvg from './svg/AddSvg.vue';

export default defineComponent({
  name: 'AddIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      AddSvg: markRaw(AddSvg)
    };
  }
});
